import React, { useState } from "react";
import { Table, Input, Form } from "antd";
import { motion } from "framer-motion";
import { Loader } from "../Loader/Loader";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => (
  <td {...restProps}>
    {editing ? (
      <Form.Item
        name={dataIndex}
        style={{ margin: 0 }}
        rules={[{ required: false }]}
      >
        <Input />
      </Form.Item>
    ) : (
      children
    )}
  </td>
);

// ✅ Animate each row using motion.div (more reliable)
const MotionRow = (props) => {
  const { className, style, children, "data-row-key": key, ...rest } = props;

  return (
    <motion.tr
      {...rest}
      key={key}
      initial={{
        opacity: 0,
        rotateX: -75, // more natural fold angle
        // scale: 0.95,
        y: 20,
        transformOrigin: "top center",
      }}
      animate={{
        opacity: 1,
        rotateX: 0,
        // scale: 1,
        y: 0,
      }}
      transition={{
        duration: 0.3,
        delay: key * 0.08,
        ease: [0.22, 1, 0.36, 1], // smooth cubic-bezier (easeOutExpo)
      }}
      className={className}
      style={{
        ...style,
        transformStyle: "preserve-3d",
        backfaceVisibility: "hidden",
        perspective: 100, // adds realistic depth
      }}
    >
      {children}
    </motion.tr>
  );
};
const TradeTable = ({
  columns,
  data,
  scroll,
  className,
  onRow,
  pagination = false,
  onPaginationChange,
  loading,
}) => {
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState("");

  const isEditing = (record) => record.key === editingKey;

  const mergedColumns = columns.map((col) => {
    if (!col.editable) return col;
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <Form form={form} component={false} className="table-container">
      {loading ? (
        <div style={{ height: "170px" }}>
          <Loader />
        </div>
      ) : (
        <Table
          components={{
            body: {
              row: MotionRow,
              cell: EditableCell,
            },
          }}
          columns={mergedColumns}
          dataSource={data}
          pagination={
            pagination && {
              ...pagination,
              onChange: (page, pageSize) => {
                if (onPaginationChange) onPaginationChange(page, pageSize);
              },
            }
          }
          bordered
          className={className}
          scroll={scroll}
          onRow={onRow}
          loading={loading}
        />
      )}
    </Form>
  );
};

export default TradeTable;
